module.exports = __webpack_public_path__ + "static/media/galt (2).be1cc571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/galt (2).jpg
// module id = 496
// module chunks = 0